import { Box, Typography } from '@mui/material'
import React from 'react'
import Logo from "../assets/jumpstartcxo_logo.svg";

const Footer = () => {
  return (
   <Box className="cf_footer">
    <Typography variant="caption">powered by</Typography>
    <img src={Logo} className="jumpstartcxo_logo" />
   </Box>
  )
}

export default Footer